import { BookingState } from "@/lib/redux/features/booking/type"
import dayjs from "dayjs"
import { getValidDayjs } from "../safeParse/getValidDayjs"

export const getQueryStringSearchFlightDynamic = ({
  chd,
  inf,
  adt,
  itinerary,
  isMultiCities,
  flights,
  cabinClass
}: {
  adt: number,
  chd: number,
  inf: number,
  flights: BookingState['flights'],
  cabinClass: string,
  itinerary: boolean,
  isMultiCities: boolean
}) => {

  const inputAdult = adt
  const inputChildren = chd
  const inputInfant = inf
  const checkedItinerary = itinerary
  const inputFlights = Object.values(flights).sort(({ isReturn }) => (isReturn ? 1 : -1))

  const params = new URLSearchParams()
  params.set('adult', `${inputAdult}`)
  params.set('child', `${inputChildren}`)
  params.set('infant', `${inputInfant}`)
  params.set('itinerary', checkedItinerary && !isMultiCities ? '1' : '0')
  for (let i = 0; i < inputFlights.length; i++) {
    
    const input = inputFlights[i];
    if (input.isReturn) {
      continue
    }
    const toAirport = input.toAirport
    const fromAirport = input.fromAirport
    const dateFrom = getValidDayjs(input.dateFrom)
    const dateTo = getValidDayjs(checkedItinerary && !isMultiCities ? inputFlights.find(f => f.isReturn)?.dateTo : input.dateTo)

    params.set(`t${i + 1}`, toAirport?.code || '')
    params.set(`f${i + 1}`, fromAirport?.code || '')
    dateFrom && params.set(`df${i + 1}`, dateFrom.format("YYYY-MM-DD"))
    dateTo && checkedItinerary && params.set(`dt${i + 1}`, dateTo.format("YYYY-MM-DD"))
  }

  params.set('class', cabinClass)

  return params.toString()
}